import FastMarquee from "react-fast-marquee";

const PHRASES = ["RIDE TOGETHER", "ARRIVE TOGETHER", "STAY CONNECTED", "NO ONE LEFT BEHIND"];

export const EditorialMarquee = () => (
  <div
    className="relative border-y border-white/10 bg-[#08080a] py-6 sm:py-8"
    data-testid="editorial-marquee"
  >
    <FastMarquee speed={28} gradient={false} pauseOnHover={false}>
      {PHRASES.concat(PHRASES).map((p, i) => (
        <span key={i} className="mx-8 flex items-center gap-16 sm:mx-12">
          <span
            className={`font-display text-3xl font-black tracking-tight sm:text-5xl ${
              i % 2 === 0 ? "text-outline" : "text-white/90"
            }`}
          >
            {p}
          </span>
          <span className="h-2 w-2 rounded-full bg-[#FF3333]" aria-hidden="true" />
        </span>
      ))}
    </FastMarquee>
  </div>
);
